import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import Circular from "../Circular/Circular";
import Button from "components/CustomButtons/Button.js";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import MenuItem from "@material-ui/core/MenuItem";
import TextField from "@material-ui/core/TextField";
import Grid from '@material-ui/core/Grid';
import { updateOrder } from "../../services/orders/orders";
import { getAllUsers, getMe } from "../../services/users/users";
import { sendAction } from "../../services/lockers/lockers";
import { createEvent } from "../../services/events/events";
import MomentUtils from "@date-io/date-fns";
import pt from "date-fns/locale/pt";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker
} from '@material-ui/pickers';

const useStyles = (theme) => ({
  iconView: {
    color: "gray !important",
  },
  root: {
    "& .MuiFormControl-root": {
      margin: theme.spacing(1),
      width: 200,
    },
  },
  dialog: {
    "& .MuiPaper-root": {
      margin: theme.spacing(1),
      width: 250,
      height: 200,
    },
  },
  green: {
    "& label.Mui-focused": {
      color: "green",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "green",
    },
    webKitCalendarPickerIndicator: {
      display: "none",
    },
  },
  red: {
    "& label.Mui-focused": {
      color: "red",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "red",
    },
  },
});

class EditOrder extends Component {
  constructor(props) {
    super(props);
    this.updateOrders = this.updateOrders.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleDateChangeInit = this.handleDateChangeInit.bind(this);

    this.state = {
      order: {},
      role: null,
      waiting: false,
      orderStatus: [
        {
          value: "reserved",
          label: "Reservada",
        },
        {
          value: "pre_allocated",
          label: "Pré-depositada",
        },
        {
          value: "allocated",
          label: "Depositada",
        },
        {
          value: "expired",
          label: "Expirada",
        },
        {
          value: "collected",
          label: "Coletada",
        },
        {
          value: "unableTocollect",
          label: "Encomenda presa"
        }
      ],
      sizes: [
        {
          size: "small",
          pt: "Pequena",
        },
        {
          size: "medium",
          pt: "Média",
        },
        {
          size: "large",
          pt: "Grande",
        },
        {
          size: "extra-large",
          pt: "Extra Grande",
        },
      ],
      status: this.props.order.status === "pre_allocated" ? "allocated" : (this.props.order.status === "addressed" ? "reserved" : this.props.order.status),
      originalStatus: this.props.order.status,
      pne: this.props.order.pne,
      categories: [
        {
          value: false,
          label: "sem restrição",
        },
        {
          value: true,
          label: "deficiente físico",
        },
      ],
      expiredAt: this.props.order.expiredAt ? this.props.order.expiredAt : null,
      currentUser: JSON.parse(localStorage.getItem("user")).data
    };
  }

  componentDidMount () {
    const user = JSON.parse(localStorage.getItem('user'));
    // getAllUsers((users) => {
    //   let currentUser = users.filter(u => u.email === user.data.email)[0];
    //   if (currentUser && currentUser.roleName)
    //     this.setState({ role: currentUser.roleName });
    // });
    getMe((currentUser) => {
      if (currentUser && currentUser.roleName)
        this.setState({ role: currentUser.roleName });
    });
  }

  updateOrders = () => {
    const { status, pne, expiredAt } = this.state;

    let orderUp = {
      status,
      pne,
      expiredAt
    };

    console.log(JSON.stringify(orderUp), this.props.order.lockerId, this.props.order.id)

    updateOrder(this.props.order.lockerId, this.props.order.id, orderUp, (data) => {
      this.setState({ order: {}, waiting: false });
      this.props.onChange(false);
      if (data) {
        this.props.setNotification(
          "Encomenda editada com sucesso!",
          "success"
        )

        sendAction(this.props.order.lockerId, 'pollingNow', 'Action', (resp) => console.log(resp));
        const labelStatus = this.state.orderStatus.find(status => orderUp.status == status.value);


        let d = {
          'lockerId': this.props.order.lockerId,
          'parametro1': this.props.order.slot.label,
          'code': '104',
          'encomenda': this.props.order.deliveryToken,
          'usuario': this.state.currentUser.name,
          'complemento': `Encomenda atualizada para ${labelStatus.label}`
        };

        createEvent(d, () => {
          console.log(`Creted event`);
        });

      } else {
        this.props.setNotification("Encomenda não foi editada!", "danger");
      }
    });
  };

  handleCancel = () => {
    this.setState({ waiting: true });
    this.updateOrders();
  };

  handleClose = () => {
    this.props.onChange(false);
  };

  handleChangeStatus = (e) => {
    this.setState({ status: e.target.value });
  };

  handleChange = (event) => {
    this.setState({ pne: event.target.value });
  }

  handleDateChangeInit (expiredAt) {
    if ((new Date(expiredAt)).getTime() < (new Date()).getTime()) {
      this.setState({ status: 'expired' });
    }

    if ((new Date(expiredAt)).getTime() > (new Date()).getTime() && this.state.status === 'expired') {
      this.setState({ status: 'pre_allocated' });
    }

    this.setState({ expiredAt });
  }

  render () {
    const { classes } = this.props;
    const { sizes, status, orderStatus, waiting, pne, categories, expiredAt, role } = this.state;
    return (
      <div>
        <Dialog
          className={waiting ? classes.dialog : null}
          open={this.props.open}
          onClose={this.handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {waiting ? "Editando Encomenda" : "Editar Encomenda"}
          </DialogTitle>
          <DialogContent>
            {waiting ? (
              <div>
                <Circular />
              </div>
            ) : (
              <form className={classes.root} noValidate autoComplete="off">
                <div className="align-fields">
                  <TextField
                    className={classes.green}
                    label="Porta"
                    value={
                      this.props.order.slotName
                        ? this.props.order.slotName
                        : this.props.order.slotId
                    }
                    disabled
                  ></TextField>
                  <TextField
                    className={classes.green}
                    label="Encomenda ID"
                    value={this.props.order.id}
                    disabled
                  ></TextField>
                  <TextField
                    className={classes.green}
                    label="Status"
                    onChange={this.handleChangeStatus}
                    select
                    value={status}
                    disabled={(role !== 'Gestor' && role !== 'Supervisor' && role !== 'Administrador') ? true : false}
                  >
                    {orderStatus.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>
                  <TextField
                    className={classes.green}
                    label="Tamanho"
                    value={this.props.order.size ? sizes.filter(s => s.size === this.props.order.size)[0].pt : null}
                    disabled
                  ></TextField>
                  <TextField
                    className={classes.green}
                    label="Código da encomenda"
                    value={this.props.order.deliveryToken}
                    disabled
                  ></TextField>
                  {/* <TextField
                    className={classes.green}
                    label="AWB"
                    value={this.props.order.deliveryToken}
                    disabled
                  ></TextField> */}
                  <TextField
                    className={classes.green}
                    label="Tranportador"
                    value={(status === "allocated" || status === "pre_allocated" || status === "addressed" || status === "reserved") ? "Correios" : status === "allocatedClient" ? "Cliente" : "-"}
                    disabled
                  ></TextField>
                  <TextField
                    className={classes.green}
                    label="Celular"
                    value={this.props.order.mobile_phone}
                    disabled
                  ></TextField>
                  <TextField
                    className={classes.green}
                    select
                    name="category"
                    label="Categoria"
                    value={pne}
                    onChange={this.handleChange}
                    disabled={(role !== 'Gestor' && role !== 'Supervisor' && role !== 'Administrador') ? true : false}
                  >
                    {categories.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>
                  <div style={{ width: '100%' }}>
                    <MuiPickersUtilsProvider utils={MomentUtils} locale={pt}>
                      <Grid container justify="space-around">
                        <KeyboardDatePicker
                          locale="pt"
                          variant="inline"
                          format="dd/MM/yyyy"
                          label="Data expiração"
                          value={expiredAt}
                          onChange={this.handleDateChangeInit}
                          disabled={(role !== 'Gestor' && role !== 'Supervisor' && role !== 'Administrador') ? true : false}
                        />
                      </Grid>
                    </MuiPickersUtilsProvider>
                  </div>
                </div>
              </form>
            )}
          </DialogContent>
          <DialogActions>
            {waiting ? null : (
              <div>
                <Button onClick={this.handleClose} color="default">
                  Voltar
                </Button>
                <Button onClick={this.handleCancel} color="success" autoFocus disabled={(role !== 'Gestor' && role !== 'Supervisor' && role !== 'Administrador') ? true : false}>
                  Editar
                </Button>
              </div>
            )}
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}
export default withStyles(useStyles)(EditOrder);
